export default "__VITE_ASSET__D11xOe7s__"